var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHungTinTon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4263 8.37484V0.00390625L8.37891 1.75964V10.1306L11.4263 8.37484Z",
    fill: "#6CBE45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5669 18.6229V27.0005L15.6143 25.2448V16.8672L12.5669 18.6229Z",
    fill: "#6CBE45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37891 16.2104V25.2453L11.4263 27.001V18.0307L16.7577 14.956V24.5858L19.8051 22.8323V4.1698L16.7577 2.41406V11.3844L8.37891 16.2104Z",
    fill: "#6CBE45"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23564 2.41748L4.19043 4.17321V22.8312L7.23564 24.5847V15.6145L15.6144 10.7884V1.75574L12.567 0V8.97029L7.23564 12.0406V2.41748Z",
    fill: "#6CBE45"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05191 4.82812L0.464372 6.31872C0.20986 6.46577 0 6.7933 0 7.04953V19.9502C0 20.2064 0.205395 20.5339 0.46214 20.681L3.04744 22.1716V4.82812H3.05191Z",
    fill: "#6CBE45"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9482 22.1716L23.5358 20.681C23.7925 20.5339 24.0001 20.2064 24.0001 19.9502V7.04953C24.0001 6.7933 23.7903 6.46577 23.5358 6.31872L20.9482 4.82812V22.1716Z",
    fill: "#6CBE45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHungTinTon);
export default __webpack_public_path__ + "static/media/HungTinTon.02408dda163f67a2c3206ae2088fbdd0.svg";
export { ForwardRef as ReactComponent };